import React from "react";
import Sidebar from "../components/Sidebar/sideBar";
import Header from "../components/Hearder/Header";
import { makeStyles } from "@mui/styles";
import Container from "@mui/material/Container";
import clsx from "clsx";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../components/redux/modules/globalSlice";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  container: {
    // width: "100%",
    // padding: theme.spacing(3),
  },
  contentContainer: {
    // width: "100%",
    // overflow: "auto",
  },
  content: {
    flexGrow: 1,

    // transition: theme.transitions.create("margin", {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
    // marginLeft: -drawerWidth,
  },
  contentShift: {
    // transition: theme.transitions.create("margin", {
    //   easing: theme.transitions.easing.easeOut,
    //   duration: theme.transitions.duration.enteringScreen,
    // }),
    // marginLeft: 0,
  },
}));

export default function AuthLayout(props) {
  const classes = useStyles();

  const { sidebarOpen } = useSelector((state) => state.global.sidebar);
  const dispatch = useDispatch();

  const handleDrawerToggle = () => {
    if (sidebarOpen) {
      document.body.classList.add("sb-sidenav-toggled");
    } else {
      document.body.classList.remove("sb-sidenav-toggled");
    }
    dispatch(toggleSidebar(!sidebarOpen));
  };

  const handleDrawerOpen = () => {
    dispatch(toggleSidebar(true));
  };

  const handleDrawerClose = () => {
    dispatch(toggleSidebar(false));
  };

  useMediaQuery({ query: `(max-width: 768px)` }, undefined, (matches) => {
    matches ? handleDrawerClose() : handleDrawerOpen();
  });

  return (
    <div className={classes.root}>
      {/* <Sidebar open={sidebarOpen} onDrawerClose={handleDrawerClose} /> */}

      <div
        id="page-content-wrapper"
        className={clsx(classes.content, {
          [classes.contentShift]: sidebarOpen,
        })}
      >
        <Header open={sidebarOpen} onDrawerToggle={handleDrawerToggle} />
        <Container maxWidth={false} sx={{maxWidth:'1670px'}}>
        {/* <Container className={classes.container} maxWidth={false}> */}
          <div className={classes.contentContainer}>
            {props.children} {/* render component */}
          </div>
        </Container>
      </div>
    </div>
  );
}
